import { Pagination } from "@mui/material";
import { MoreHorizontal } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { checkTagValidity } from "../../Utils/Utils";
import { ADD_FORFAIT, DELETE_FORFAIT } from "../../Utils/constant";
import { ForfaitForm } from "../../components/Forfait/ForfaitForm";
import { Home } from "../../components/Icons/Home";
import { Loader } from "../../components/Widget/Loader";
import { deleteOne, store } from "../../services/service";
import { useStoreEquipement } from "../../store/Paramettre/equipementStore";
import { useStoreForfait } from "../../store/Paramettre/forfaitStore";

export const Forfait = () => {
  const forfait = useStoreForfait();
  const typeEquipements = useStoreEquipement();
  const [selectItem, setSelectItem] = useState(null);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const [selectType, setSelectType] = useState("");

  const submit = (data) => {
    setIsSubmit(true);
    store(ADD_FORFAIT, "application/json", data)
      .then((res) => {
        setIsSubmit(false);
        if (res.status === 200) {
          reset();
          document.getElementById("fermer_create_trajet").click();
          toast.success("Forfait ajouté");
          forfait.forfait({ page: 0, param: "", size: 10 });
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err.response.data.donnee);
      });
  };
  useEffect(() => {
    reset();
    forfait.forfait({ page: 0, param: "", size: 10 });
    typeEquipements.equipement({ page: 0, param: "", size: 10 });
  }, []);

  const more = (page) => {
    forfait.forfait({ page: page - 1, param: "", size: 10 });
  };

  return (
    <>
      <div>
        <div className="mt-4 lg:flex item-center ">
          {/* <h1 className="text-2xl font-extrabold text-black">Type d'équipements</h1> */}
          <input
            type="text"
            placeholder="Rechercher element..."
            className="input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
          />
          <div className="ml-auto">
            {checkTagValidity("AJOUTER_FORFAIT") ? (
              <button
                onClick={() =>
                  document.getElementById("type_equip").showModal()
                }
                className="btn btn-sm bg-main rounded-md text-black text-xs hover:bg-gray-900 hover:text-white"
              >
                Ajouter un forfait
              </button>
            ) : null}

            <dialog id="type_equip" className="modal ">
              <div className="modal-box ">
                <div className="modal-action">
                  <h1 className="mr-auto text-2xl font-bold">
                    Ajouter un forfait
                  </h1>
                  <form method="dialog">
                    <button
                      id="fermer_create_trajet"
                      className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                    >
                      ✕
                    </button>
                  </form>
                </div>
                <form onSubmit={handleSubmit(submit)} className="px-2">
                  <div className="my-4 space-y-4">
                    <div className="my-2">
                      <label htmlFor="" className="text-sm font-medium">
                        Designation <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder=""
                        className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                        {...register("designation", { required: true })}
                      />
                      {errors.designation && (
                        <span className="text-sm text-rose-600">
                          Ce champs est obligatoire
                        </span>
                      )}
                    </div>
                    <div className="my-2">
                      <label htmlFor="" className="text-sm font-medium">
                        Code de souscription{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder=""
                        className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                        {...register("codeSouscription", { required: true })}
                      />
                      {errors.codeSouscription && (
                        <span className="text-sm text-rose-600">
                          Ce champs est obligatoire
                        </span>
                      )}
                    </div>
                    <div className="my-2">
                      <label htmlFor="" className="text-sm font-medium">
                        OfferId <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder=""
                        className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                        {...register("offerId", { required: true })}
                      />
                      {errors.offerId && (
                        <span className="text-sm text-rose-600">
                          Ce champs est obligatoire
                        </span>
                      )}
                    </div>

                    <div>
                      <label className="text-sm font-medium">
                        Type d'équipement{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <select
                        {...register("typeEquipementId", { required: true })}
                        onChange={(e) => setSelectType(e.target.value)}
                        className="select select-bordered w-full h-10"
                      >
                        <option value={""} selected>
                          type d'équipement
                        </option>
                        {typeEquipements?.data?.equipements?.map((item) => (
                          <option value={item.id}>{item.designation}</option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="text-sm font-medium">
                        Categorie de forfait{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <select
                        {...register("categorie", { required: true })}
                        className="select select-bordered w-full h-10"
                      >
                        <option value={""} selected></option>
                        <option value="PRE_PAID">Forfait prepayé</option>
                        <option value="POST_PAID">Forfait postpayé</option>
                      </select>
                    </div>

                    <div className="my-2">
                      <textarea
                        {...register("description")}
                        className="textarea textarea-bordered w-full"
                        placeholder="Avantage du forfait"
                      ></textarea>
                    </div>

                    <button
                      type="submit"
                      disabled={isSubmit ? true : false}
                      className={`${
                        !isSubmit
                          ? "text-black bg-main"
                          : "text-slate-800 bg-slate-200 "
                      } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
                    >
                      {!isSubmit ? "Enregistrer" : "Veuillez patientez..."}{" "}
                      {isSubmit ? (
                        <span className="loading loading-dots loading-xs"></span>
                      ) : null}
                    </button>
                  </div>
                </form>
              </div>
            </dialog>
          </div>
        </div>
        <dialog id="forfait_upadate" className="modal ">
          <div className="modal-box ">
            <div className="modal-action">
              <h1 className="mr-auto text-2xl font-bold">
                Modification d'un forfait
              </h1>

              <form method="dialog">
                <button
                  id="fermer"
                  className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                >
                  ✕
                </button>
              </form>
            </div>
            <ForfaitForm item={selectItem} />
          </div>
        </dialog>
        <div className="grid md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-6 gap-2 my-8">
          {forfait?.data?.data?.length === 0 ? (
            "Aucune donnée"
          ) : forfait?.data?.data?.length !== 0 && !forfait?.loading ? (
            forfait?.data?.data?.map((item) => (
              <div className="relative flex gap-1 items-center cursor-pointer text-black shadow-sm border bg-white  rounded text-xs">
                <div className="dropdown dropdown-end absolute right-2 top-2">
                  <div
                    tabIndex={0}
                    role="button"
                    className="w-4 h-4 rounded-full flex items-center justify-center bg-gray-50"
                  >
                    <MoreHorizontal size={20} />
                  </div>
                  <ul
                    tabIndex={0}
                    className="mt-1 dropdown-content z-[1] menu p-2 border shadow bg-base-100 rounded-lg w-44"
                  >
                    <button
                      className="bg-white hover:bg-gray-100 text-gray-600 font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                      onClick={() => {
                        setSelectItem(item);
                        document.getElementById("forfait_upadate").showModal();
                      }}
                    >
                      Modifier
                    </button>
                    <button
                      onClick={() => {
                        setSelectItem(item);
                        document.getElementById("delete").showModal();
                      }}
                      className="bg-white hover:bg-red-600 text-black hover:text-white font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                    >
                      Supprimer
                    </button>
                  </ul>
                </div>
                <div className="bg-gray-100 w-10 h-10 rounded m-1 flex items-center justify-center">
                  <Home />
                </div>
                <div className="space-y-1">
                  <p className="truncate w-28">{item?.designation}</p>
                  <p className="truncate w-fit bg-gray-200 rounded-full px-2 text-black">
                    {item?.categorie?.replace("_", " ").toLowerCase()}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <Loader />
          )}
        </div>
        <div className="my-3 flex justify-end">
          <Pagination
            onChange={(event, newValue) => more(newValue)}
            onSelect={(selectedPage) => more(selectedPage)}
            count={forfait.count}
            variant="outlined"
            color="primary"
            shape="rounded"
          />
        </div>
        <dialog id="delete" className="modal">
          <div className="modal-box max-w-md rounded-lg">
            <h3 className="font-extrabold text-xl text-red-600 ">Attention</h3>
            <p className="pt-2 text-black font-medium">
              Voulez vous vraiment effectuer cette action ?
            </p>
            <div className="modal-action">
              <form
                method="dialog"
                className="w-full flex items-center justify-end gap-x-4"
              >
                <button className="bg-gray-100 text-gray-600 w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                  Annuler
                </button>
                <button
                  onClick={() => {
                    deleteOne(DELETE_FORFAIT, selectItem.id)
                      .then(() => {
                        forfait.forfait({ page: 0, param: "", size: 10 });
                        toast.success(
                          `${selectItem.designation + " supprimé"}`
                        );
                      })
                      .catch((err) => {});
                  }}
                  className="bg-red-600 text-white w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold"
                >
                  Supprimer
                </button>
              </form>
            </div>
          </div>
        </dialog>
      </div>
    </>
  );
};
